// #region Imports
import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import FeeScheduleExistingTemplate from "work/fee-schedule-templates/_views/lists/fee-schedule-template-list";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";
// #endregion

// #region Styled Components
const Drawer = styled(MuiDrawer)(() => ({
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    height: 'calc(100% - 64px)',
    top: '64px',
    width: '400px',
    boxSizing: 'border-box',
  },
}));
const FeeTemplatePanel = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "closeAfterTransition"
})<{ open?: boolean }>(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    width: open ? "400px" : 0,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: open
        ? theme.transitions.easing.easeOut
        : theme.transitions.easing.sharp,
      duration: open
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
  },
}));
const FeeTemplatePanelContainer = styled("div")(() => ({
  flex: 1,
  height: "100%",
  minHeight: 0,
}));
const FeeTemplatePanelContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: "100%",
  minHeight: 0,
  padding: theme.spacing(2),
  width: "400px",
}));
const TitleBar = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  paddingBottom: theme.spacing(1),
}));
// #endregion

// #region Props/Types
type ExistingFeeScheduleTemplateDrawerProps = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onTemplateSelected: (template: FeeScheduleTemplate) => void;
};
// #endregion

export default function ExistingFeeScheduleTemplateDrawer(props: Readonly<ExistingFeeScheduleTemplateDrawerProps>) {
  const {
    isOpen,
    onClose,
    onTemplateSelected,
  } = props;

  // #region Render
  return (
    <FeeTemplatePanel open={isOpen} anchor="right" variant="persistent" closeAfterTransition={false}>
      <FeeTemplatePanelContainer>
        <FeeTemplatePanelContent>
          <TitleBar>
            <Typography variant="h5">Select Existing Template</Typography>
            <Tooltip title="Minimize panel">
              <IconButton size="medium" onClick={onClose}>
                <KeyboardTabIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </TitleBar>
          <FeeScheduleExistingTemplate
            onTemplateSelected={onTemplateSelected}
          />
        </FeeTemplatePanelContent>
      </FeeTemplatePanelContainer>
    </FeeTemplatePanel>
  );
}
// #endregion
